// import { createSelector } from 'reselect';

export const getAbout = state => state.getIn(['aboutUs', 'about']);
